import React, {useState} from "react";
import swal from 'sweetalert'
import {header} from "../../Components/Url/ApiUrl";
import {useTranslation} from "react-i18next";
const CompanyServiceTextEditModal = ({show, handleClose, model, onSuccess}) => {
    const {t} = useTranslation();
    const [webInfo, setWebInfo] = useState(model.hududlar_web)
    const [equipmentInfo, setEquipmentInfo] = useState(model.additional_info)
    const handleValidatedSave = () => {
        if(webInfo === model.hududlar_web && equipmentInfo === model.additional_info){
            handleClose()
            return
        }
        const formData = new FormData();
        formData.append("hududlar_web", webInfo);
        formData.append("additional_info", equipmentInfo);
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/company/company-services`,{
            method: "POST",
            body: formData,
            headers:header
        }).then((res) => {
            if (res.ok) {
                swal(t('success'),t('saved'),"success");
                onSuccess()
                handleClose()
            } else {
                swal(t('error'),t('translation:error_occured'),'warning');
            }
        });
    }

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            id="editModal"
            tabIndex="-1"
            aria-labelledby="editModalLabel"
            style={{display: show ? "block" : "none", background: "rgba(0, 0, 0, 0.65)"}}
        >
            <div className="modal-dialog" style={{maxWidth: "1000px"}}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="editModalLabel">
                            {t('edit_information')}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            {t('about_service_center')}:
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows={3}
                                            value={webInfo}
                                            onChange={(e) => setWebInfo(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            {t('accesory_store')}:
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows={3}
                                            value={equipmentInfo}
                                            onChange={(e) => setEquipmentInfo(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {t('translation:cancel')}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleValidatedSave}>
                            {t('save')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompanyServiceTextEditModal